import Axios from 'axios'

import { parseAuthenticationHeader } from 'helpers/Functions'

import {
  TSlice,
  TSliceFilterCondition,
  TSliceFilterConditionType
} from 'types/GlobalSlice'

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const URL = `${BASE_URL}v1/slices`

export interface IPostSliceBody {
  name: string
  entity_id: string
}
export interface IPatchSliceBody {
  name?: string | null // allow null for standard alias
  filters?: {
    entity_column_id: string
    type: TSliceFilterConditionType
    condition: TSliceFilterCondition
    right_value: string | null

    // any key shared by filters that should be OR:ed with each other.
    // the backend maps it to a persisted group id.
    filter_group_id: string | null
  }[]
}

export async function getAll() {
  return Axios.get<{ data: TSlice[] }>(URL, parseAuthenticationHeader())
}

export async function create(body: IPostSliceBody) {
  return Axios.post<{ data: TSlice }>(
    URL,
    { data: body },
    parseAuthenticationHeader()
  )
}

export async function update(id: string, body: IPatchSliceBody) {
  return Axios.patch<{ data: TSlice }>(
    `${URL}/${id}`,
    { data: body },
    parseAuthenticationHeader()
  )
}

export async function destroy(id: string) {
  return Axios.delete(`${URL}/${id}`, parseAuthenticationHeader())
}
